import * as svg from './svg';

// icon which is shown on the left of the title
export default {
  crm: svg.serviceCrm,
  analytics: svg.analytics,
  voice: svg.voice,
  surveys: svg.surveys,
  email: svg.emailMarketing,
  calendar: svg.calendar,
  wiki: svg.wiki,
  helpCenter: svg.helpCenter,
  dataManagement: svg.dataManagement,
  formBuilder: svg.formBuilder,
  migration: svg.migration,
  nextIQ: svg.nextIq,
  nextOS: svg.nextOs,
  smartTopics: svg.smartTopics,
  social: svg.social,
  support: svg.support,
  tasks: svg.tasks,

  // ADMINISTRATION TOOLS:
  adminTools: svg.adminTools,
  builder: svg.adminTools,
  chat: svg.adminTools,
  crmAdmin: svg.adminTools,
  integrations: svg.adminTools,
  dataMigration: svg.adminTools,
  platformAdmin: svg.adminTools,
  rulesEngine: svg.adminTools,
};
